import { IExtensionsServerSettings } from '../types/IEditableServerSettings';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ISetRunNowForSitesParams {
  sites: string[];
  shouldEnable: boolean;
}

export type ISetRunNowForSitesResult = IResult & IExtensionsServerSettings;

export class SetRunNowForSitesRequest extends Request<ISetRunNowForSitesParams, ISetRunNowForSitesResult> {
  constructor(params: ISetRunNowForSitesParams) {
    super('setRunNowForSites', params);
  }
}
